var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"transparent"},[_c('StackedBarChart',{attrs:{"sourceData":_vm.chartData,"title":"Services"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }